import { HttpService } from './http.service';

type DataType = null | {
  latestVersion: string;
  minimumRequiredVersion: string;
  appId: string;
};

export class AppVersionService extends HttpService {
  getAppVersion() {
    return this.send<{ isSuccess: boolean; data: DataType }>({
      method: 'get',
      url: '/AppVersions',
    });
  }

  getUserChannel() {
    return this.send<{ isSuccess: boolean; data: string }>({
      method: 'get',
      url: '/AppVersions/UserChannel',
    });
  }

  async getSentryConfig() {
    return this.send<SentryConfig>({ url: '/AppVersions/SentryConfig', method: 'get' });
  }
}

type SentryConfig = {
  profilesSampleRate: number;
  replaysOnErrorSampleRate: number;
  replaysSessionSampleRate: number;
  tracesSampleRate: number;
  ignoreErrors: RegExp[];
};
